/* global femcare */

femcare.tooltip = {

    /**
     * Initializes the tooltip functionality.
     */
    init() {
        if (document.querySelector('.tooltip__container')) {
            this.initEvents();
        }
    },

    /**
    * Toggles tooltip visibility for a given UI event.
    *
    * @param {Event} event   DOM event coming from the tooltip icon or content.
    * @param {'show'|'hide'} action  Specify whether to display or hide the tooltip.
    */
    triggerTooltip(event, action) {
        event.preventDefault();
        const tooltip = event.target.closest('.tooltip__container');

        if (!tooltip) {
            return
        };

        const content = tooltip.querySelector('.tooltip__content');
        const slide = tooltip.closest('.swiper-slide');

        if (action === 'show') {
            if (slide)  {
                slide.style.transform = 'none';
            }

            tooltip.classList.add('tooltip--active');
            if (content) {
                content.setAttribute('aria-hidden', 'false');
                this.adjustPosition(content);
            }
        } else {
            if (slide)  {
                slide.style.transform = '';
            }

            tooltip.classList.remove('tooltip--active');
            if (content) {
                content.setAttribute('aria-hidden', 'true');
                content.classList.remove(
                    'tooltip__content--flip-left',
                    'tooltip__content--flip-right'
                );
            }
        }
    },

    /**
     * adjustPosition ensures that the tooltip content remains fully visible within the viewport.
     *
     * It first resets any previously applied horizontal “flip” classes, then measures the
     * element’s bounding rectangle against the current viewport width. If the tooltip
     * overflows on the right, it applies the `tooltip__content--flip-left` class and
     * rechecks; if it still overflows on the left, it reverts to the centered position.
     * Likewise, if the tooltip overflows on the left initially, it applies
     * `tooltip__content--flip-right` and reverts if it still overflows on the right.
     *
     * @param {HTMLElement} content - The tooltip content element to adjust.
     */
    adjustPosition(content) {
        if (!content) { return };

        content.classList.remove(
            'tooltip__content--flip-left',
            'tooltip__content--flip-right'
        );

        const vw = document.documentElement.clientWidth;
        let rect = content.getBoundingClientRect();

        if (rect.right > vw) {
            content.classList.add('tooltip__content--flip-left');
            rect = content.getBoundingClientRect();
            if (rect.left < 0) {
                content.classList.remove('tooltip__content--flip-left');
            }
        } else if (rect.left < 0) {
            content.classList.add('tooltip__content--flip-right');
            rect = content.getBoundingClientRect();
            if (rect.right > vw) {
                content.classList.remove('tooltip__content--flip-right');
            }
        }
    },

    /**
    * Binds mouse, focus, and keyboard events to show or hide tooltips.
    * No parameters – it simply attaches handlers to elements on the page.
    */
    initEvents() {
        const elements = document.querySelectorAll('.tooltip-icon-btn, .tooltip__content');

        const show = e => this.triggerTooltip(e, 'show');
        const hide = e => {
            if (e.type === 'keydown' && e.key !== 'Escape') {
                return
            };

            this.triggerTooltip(e, 'hide');
        };

        elements.forEach(el => {
            el.addEventListener('click', show);
            el.addEventListener('mouseover', show);
            el.addEventListener('focus', show);
            el.addEventListener('mouseout', hide);
            el.addEventListener('focusout', hide);
            el.addEventListener('keydown', hide);
        });
    }
};